import React from "react";
import "../css/ChristmasTheme.css";
import "../css/garlandChristmas.css";
// import SantaRunning from "../../../assets/img/gif/santaRunning.gif";
// import SantaSlay from "../../../assets/image/gif/santa.gif";
/** Christmas is only active in December */
export const isChristmasMonth = () => {
  const month = new Date().getMonth() + 1;
  return month === 10 || month === 11 || month === 12;
};

export const ChristmasSnow = () => {
  if (!isChristmasMonth()) return null;
  return (
    <div className="christmas-snowflakes" aria-hidden="true">
      <span>❄️</span>
      <span>🌲</span>
      <span>🎁</span>
      <span>❄️</span>
      <span>🌲</span>
      <span>🎁</span>
      <span>❄️</span>
      <span>🌲</span>
    </div>
  );
};

export const PlayingSnowmen = () => {
  if (!isChristmasMonth()) return null;
  return (
    <div className="playing-snowmen-container" aria-hidden="true">
      <span className="snowman snowman-left">⛄</span>
      <span className="tossed-gift">🎁</span>
      <span className="snowman snowman-right">⛄</span>
    </div>
  );
};

export const ChristmasGarland = () => {
  if (!isChristmasMonth()) return null;

  const lights = Array.from({ length: 16 });
  const colors = ["#e74c3c", "#f1c40f", "#2ecc71", "#3498db"];

  return (
    <div className="christmas-garland" aria-hidden="true">
      <svg
        className="garland-wire"
        viewBox="0 0 1600 40"
        preserveAspectRatio="none"
      >
        <path
          d="M0,0 Q50,40 100,0 T200,0 T300,0 T400,0 T500,0 T600,0 T700,0 T800,0 T900,0 T1000,0 T1100,0 T1200,0 T1300,0 T1400,0 T1500,0 T1600,0"
          fill="none"
          stroke="#3a5a40"
          strokeWidth="2"
        />
      </svg>
      <div className="garland-lights-row">
        {lights.map((_, i) => (
          <span
            key={i}
            className="garland-bulb"
            style={{
              background: colors[i % colors.length],
              animationDelay: `${(i % 5) * 0.3}s`,
            }}
          />
        ))}
      </div>
    </div>
  );
};

const ChristmasTheme = ({ children, className = "" }) => {
  if (!isChristmasMonth()) return children || null;
  return (
    <div className={`christmas-theme-wrapper ${className}`}>
      <ChristmasSnow />
      <PlayingSnowmen />
      <ChristmasGarland />
      {children}
    </div>
  );
};

export default ChristmasTheme;
